module.exports = __webpack_public_path__ + "static/maeveGreatEscape-d5b09f33cdb77a3e17af775478ec783f.mp4";